/* propads: localized main-image zoom for the existing Focal product gallery. */
(() => {
  'use strict';

  if (!window.customElements) return;

  window.customElements.whenDefined('product-image-zoom').then(() => {
    const prototype = window.customElements.get('product-image-zoom').prototype;
    const originalBuildItems = prototype._buildItems;

    if (prototype.__propadsLocalizedHeroZoom || typeof originalBuildItems !== 'function') return;

    Object.defineProperty(prototype, '__propadsLocalizedHeroZoom', { value: true });

    prototype._buildItems = async function (...args) {
      // Match Focal's ordering before its async product-data request completes.
      const activeImages = this.mediaElement
        ? Array.from(this.mediaElement.querySelectorAll('.product__media-item[data-media-type="image"]:not(.is-filtered)'))
        : [];
      const items = await originalBuildItems.apply(this, args);

      if (!activeImages.some(item => item.dataset.propadsZoomSrc)) return items;

      return items.map((item, index) => {
        const element = activeImages[index];
        const source = element?.dataset.propadsZoomSrc;
        const width = Number(element?.dataset.propadsZoomWidth);
        const height = Number(element?.dataset.propadsZoomHeight);

        if (!source || !Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return item;

        let url;
        try {
          url = new URL(source, window.location.href);
        } catch (_) {
          return item;
        }
        if (url.protocol !== 'https:' && url.protocol !== 'http:') return item;

        const displayWidth = Math.min(width, window.innerWidth);
        const pixelRatio = window.devicePixelRatio || 1;
        const zoomFactor = this.maxSpreadZoom || 2;
        const requestedWidth = Math.max(1, Math.min(width, 3000, Math.ceil(displayWidth * pixelRatio * zoomFactor)));
        url.searchParams.set('width', String(requestedWidth));

        const image = element.querySelector('img');
        return {
          ...item,
          src: url.href,
          msrc: image?.currentSrc || image?.src || item.msrc,
          w: displayWidth,
          h: Math.max(1, Math.round(displayWidth * height / width))
        };
      });
    };
  });
})();
